import React, { useEffect, useState } from "react";
import "../../Dashboard/pages/pages.css";
import api from "../../utilis/api";
import { useSelector } from "react-redux";
import "./availability.css";
const daysOfWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const timezones = [
  { label: "Eastern (New York, DC) - UTC-5", value: "-05:00" },
  { label: "Central (Chicago, Dallas) - UTC-6", value: "-06:00" },
  { label: "Mountain (Denver, Phoenix) - UTC-7", value: "-07:00" },
  { label: "Pacific (Los Angeles, SF) - UTC-8", value: "-08:00" },
  { label: "Alaska (Anchorage) - UTC-9", value: "-09:00" },
  { label: "Hawaii (Honolulu) - UTC-10", value: "-10:00" },
];

const Availability = () => {
  const { user } = useSelector((state) => state.auth);

  const [availability, setAvailability] = useState(
    daysOfWeek.map((day) => ({
      day,
      active: false,
      timezone: "-05:00",
      slots: [
        {
          startHour: 9,
          startMinute: "00",
          startMeridiem: "AM",
          endHour: 5,
          endMinute: "00",
          endMeridiem: "PM",
        },
      ],
    })),
  );
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState({ text: "", type: "" });

  // Toggle day active/inactive
  const toggleDay = (index) => {
    setAvailability((prev) => {
      const next = [...prev];
      next[index].active = !next[index].active;
      return next;
    });
  };

  // Add slot
  const addSlot = (dayIndex) => {
    setAvailability((prev) => {
      const next = [...prev];
      next[dayIndex].slots.push({
        startHour: 9,
        startMinute: "00",
        startMeridiem: "AM",
        endHour: 5,
        endMinute: "00",
        endMeridiem: "PM",
      });
      return next;
    });
  };

  // Remove slot
  const removeSlot = (dayIndex, slotIndex) => {
    setAvailability((prev) => {
      const next = [...prev];
      next[dayIndex].slots.splice(slotIndex, 1);
      return next;
    });
  };

  // Handle slot time change
  const handleTimeChange = (dayIndex, slotIndex, field, value) => {
    setAvailability((prev) => {
      const next = [...prev];
      next[dayIndex].slots[slotIndex][field] = value;
      return next;
    });
  };

  // Convert 12-hour to 24-hour
  const convertTo24Hour = (hour, minute, meridiem) => {
    let h = parseInt(hour);
    if (meridiem === "PM" && h !== 12) h += 12;
    if (meridiem === "AM" && h === 12) h = 0;
    return `${h.toString().padStart(2, "0")}:${minute}`;
  };

  // Save availability
  const handleSave = async () => {
    setSaving(true);
    setMsg({ text: "", type: "" });

    const formattedAvailability = availability.map((day) => ({
      day: day.day,
      isActive: day.active,
      timezone: day.timezone,
      slots: day.active
        ? day.slots.map((slot) => ({
            start: convertTo24Hour(
              slot.startHour,
              slot.startMinute,
              slot.startMeridiem,
            ),
            end: convertTo24Hour(
              slot.endHour,
              slot.endMinute,
              slot.endMeridiem,
            ),
          }))
        : [],
    }));

    try {
      await api.put("/teacher/availability", {
        userId: user._id,
        availability: formattedAvailability,
      });
      setMsg({ text: "Availability saved successfully!", type: "success" });
    } catch (error) {
      console.error(error);
      setMsg({
        text: error.response?.data?.message || "Error saving availability",
        type: "error",
      });
    } finally {
      setSaving(false);
    }
  };

  // Fetch teacher availability
  const getTeacher = async () => {
    try {
      const response = await api.get(`/teacher/${user._id}`);
      const teacherData = response.data.data;

      if (teacherData?.availability?.length) {
        const mapped = daysOfWeek.map((day) => {
          const dayData = teacherData.availability.find((d) => d.day === day);
          if (!dayData)
            return {
              day,
              active: false,
              timezone: "-05:00",
              slots: [
                {
                  startHour: 9,
                  startMinute: "00",
                  startMeridiem: "AM",
                  endHour: 5,
                  endMinute: "00",
                  endMeridiem: "PM",
                },
              ],
            };

          const slots = dayData.slots.map((s) => {
            const [startH, startM] = s.start.split(":");
            const [endH, endM] = s.end.split(":");
            const startMeridiem = parseInt(startH) >= 12 ? "PM" : "AM";
            const endMeridiem = parseInt(endH) >= 12 ? "PM" : "AM";
            const startHour = parseInt(startH) % 12 || 12;
            const endHour = parseInt(endH) % 12 || 12;
            return {
              startHour,
              startMinute: startM,
              startMeridiem,
              endHour,
              endMinute: endM,
              endMeridiem,
            };
          });

          return {
            day,
            active: dayData.isActive,
            timezone: dayData.timezone || "-05:00",
            slots,
          };
        });
        setAvailability(mapped);
      }
    } catch (error) {
      console.error("Error fetching teacher:", error);
    }
  };

  useEffect(() => {
    if (user?._id) getTeacher();
  }, [user]);

  return (
    <div className="overview-container availability">
      <header className="overview-header">
        <div className="header-text">
          <span className="header-subtitle">Welcome Back</span>
          <h1 className="header-title">Availability</h1>
        </div>
      </header>

      <div className="availability-card">
        {availability.map((day, dayIndex) => (
          <div
            key={day.day}
            className={`availability-row ${day.active ? "active-row" : ""}`}
          >
            <div className="day-toggle">
              <span className="day-name">{day.day}</span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={day.active}
                  onChange={() => toggleDay(dayIndex)}
                />
                <span className="slider"></span>
              </label>
            </div>

            {day.active && (
              <div className="day-settings">
                {/* Day-specific timezone */}
                <div className="timezone-select">
                  <label>Timezone:</label>
                  <select
                    value={day.timezone}
                    onChange={(e) => {
                      setAvailability((prev) => {
                        const next = [...prev];
                        next[dayIndex].timezone = e.target.value;
                        return next;
                      });
                    }}
                  >
                    {timezones.map((tz) => (
                      <option key={tz.value} value={tz.value}>
                        {tz.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Time slots */}
                <div className="time-inputs">
                  {day.slots.map((slot, slotIndex) => (
                    <div key={slotIndex} className="slot-row">
                      {/* Start Time */}
                      <select
                        value={slot.startHour}
                        onChange={(e) =>
                          handleTimeChange(
                            dayIndex,
                            slotIndex,
                            "startHour",
                            e.target.value,
                          )
                        }
                      >
                        {[...Array(12)].map((_, i) => (
                          <option key={i} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                      </select>
                      :
                      <select
                        value={slot.startMinute}
                        onChange={(e) =>
                          handleTimeChange(
                            dayIndex,
                            slotIndex,
                            "startMinute",
                            e.target.value,
                          )
                        }
                      >
                        {["00", "15", "30", "45"].map((m) => (
                          <option key={m} value={m}>
                            {m}
                          </option>
                        ))}
                      </select>
                      <select
                        value={slot.startMeridiem}
                        onChange={(e) =>
                          handleTimeChange(
                            dayIndex,
                            slotIndex,
                            "startMeridiem",
                            e.target.value,
                          )
                        }
                      >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                      <span> to </span>
                      {/* End Time */}
                      <select
                        value={slot.endHour}
                        onChange={(e) =>
                          handleTimeChange(
                            dayIndex,
                            slotIndex,
                            "endHour",
                            e.target.value,
                          )
                        }
                      >
                        {[...Array(12)].map((_, i) => (
                          <option key={i} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                      </select>
                      :
                      <select
                        value={slot.endMinute}
                        onChange={(e) =>
                          handleTimeChange(
                            dayIndex,
                            slotIndex,
                            "endMinute",
                            e.target.value,
                          )
                        }
                      >
                        {["00", "15", "30", "45"].map((m) => (
                          <option key={m} value={m}>
                            {m}
                          </option>
                        ))}
                      </select>
                      <select
                        value={slot.endMeridiem}
                        onChange={(e) =>
                          handleTimeChange(
                            dayIndex,
                            slotIndex,
                            "endMeridiem",
                            e.target.value,
                          )
                        }
                      >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                      <button
                        className="remove-slot"
                        onClick={() => removeSlot(dayIndex, slotIndex)}
                      >
                        ❌
                      </button>
                    </div>
                  ))}
                  <button
                    className="add-slot"
                    onClick={() => addSlot(dayIndex)}
                  >
                    ➕ Add Slot
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}

        {/* Status message */}
        {msg.text && (
          <div className={`status-msg ${msg.type}`}>
            {msg.type === "success" ? "✅" : "⚠️"} {msg.text}
          </div>
        )}

        <button
          className="dashboard-btn save-btn"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? "Saving..." : "Save Availability"}
        </button>
      </div>
    </div>
  );
};

export default Availability;
